// src/features/hive/ui/HiveBody/HiveBodyPhotos.tsx
import { useRef, useState } from "react";
import {
    HiveBodyPhotosContainer,
    HiveBodyUterusTitle,
    HiveBodyUterusWrapper
} from "features/hive/ui/HiveBody/styles.ts";
import { EditIcon } from "shared/ui/icons/editIcon.tsx";
import { AddLarge } from "shared/ui/icons";
import { PhotosEdit } from "features/hive/ui/PhotosEdit/PhotosEdit.tsx";
import { getAttachmentUrl, uploadImageAttachments } from "shared/api/attachments";
import {useCurrentHiveStore} from "entities/currentHive";

export const HiveBodyPhotos = () => {
    const [isOpenPhotos, setIsOpenPhotos] = useState<boolean>(false);
    const inputRef = useRef<HTMLInputElement | null>(null);
    const currentHive = useCurrentHiveStore((s) => s.currentHive);
    const updateHive = useCurrentHiveStore((s) => s.updateHive);

    const openPicker = () => inputRef.current?.click();

    const onPick = async (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!e.target.files || !currentHive) return;
        const ids = await uploadImageAttachments(e.target.files);
        if (!ids.length) {
            e.target.value = "";
            return;
        }
        const next = [...(currentHive.attachments.map((el) => el.id) || []), ...ids];
        // @ts-expect-error: несовпадение типов
        await updateHive({ attachments: next });
        e.target.value = "";
    };

    const preview = (currentHive?.attachments || []).slice(0, 3);

    return (
        <>
            <HiveBodyUterusWrapper>
                <HiveBodyUterusTitle onClick={() => setIsOpenPhotos(true)}>
                    <h3>Фото улья</h3>
                    <EditIcon />
                </HiveBodyUterusTitle>
                <HiveBodyPhotosContainer>
                    {preview.map((id) => (
                        <img key={id.id} src={getAttachmentUrl(id.id)} />
                    ))}
                    <div onClick={openPicker}>
                        <AddLarge />
                    </div>
                    <input
                        ref={inputRef}
                        type="file"
                        accept="image/*"
                        multiple
                        style={{ display: "none" }}
                        onChange={onPick}
                    />
                </HiveBodyPhotosContainer>
            </HiveBodyUterusWrapper>
            <PhotosEdit onClose={() => setIsOpenPhotos(false)} isOpen={isOpenPhotos} />
        </>
    );
};
